"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const COLOR_LIST = [{
  headerColor: '#E2E7EC',
  headerLableColor: '#98A7BE',
  footLinkColor: 'rgba(0, 0, 0, 0.6)',
  footLinkHoverColor: '#F7F7F7'
}, {
  headerColor: '#C6E6FE',
  headerLableColor: '#3CA1FF',
  footLinkColor: '#2B8BEA',
  footLinkHoverColor: '#F2F8FF'
}, {
  headerColor: '#F8E2CB',
  headerLableColor: '#E59E56',
  footLinkColor: '#C88B4E',
  footLinkHoverColor: '#FCF8F5'
}];
const formatCertificationSystem = properties => {
  const _properties$modTitle = properties.modTitle,
    modTitle = _properties$modTitle === void 0 ? '' : _properties$modTitle,
    _properties$desc = properties.desc,
    desc = _properties$desc === void 0 ? '' : _properties$desc,
    _properties$color = properties.color,
    color = _properties$color === void 0 ? '' : _properties$color,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura,
    paddingTopNum = properties.paddingTopNum,
    paddingBottomNum = properties.paddingBottomNum;
  const resultCertificationSystem = configuration.map((item, index) => {
    const cardIndex = index % 3;
    const _item$linkList = item.linkList,
      linkList = _item$linkList === void 0 ? [] : _item$linkList;
    const resultLinkList = linkList.map((link, index1) => {
      return _objectSpread(_objectSpread({}, link), {}, {
        extendProps: {
          'report-event': 'click_CertificationSystem_href',
          'report-ext1': index,
          'report-ext2': index1,
          'report-ext3': link.href || ''
        }
      });
    });
    return _objectSpread(_objectSpread(_objectSpread({}, item), COLOR_LIST[cardIndex]), {}, {
      linkList: resultLinkList
    });
  });
  return {
    modTitle,
    desc,
    color,
    paddingTopNum,
    paddingBottomNum,
    configuration: resultCertificationSystem
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  if (Object.keys(data).length > 1) {
    const _formatCertificationS = formatCertificationSystem(data),
      modTitle = _formatCertificationS.modTitle,
      desc = _formatCertificationS.desc,
      color = _formatCertificationS.color,
      configuration = _formatCertificationS.configuration,
      paddingTopNum = _formatCertificationS.paddingTopNum,
      paddingBottomNum = _formatCertificationS.paddingBottomNum;
    const bgStyle = color ? (0, _componentUtils.doComponentsBgColorEvent)(color) : {}; // 处理组件背景色
    const paddingStyle = (0, _componentUtils.doComponentsStyleEvent)({
      paddingTopNum,
      paddingBottomNum
    }); // 处理组件背景色
    paddingStyle.minWidth = 'unset';
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_CertificationSystem', componentKey, modTitle]), {
      style: bgStyle
    }), /*#__PURE__*/React.createElement(_intlDesignUi.Section, {
      title: modTitle,
      desc: desc,
      col: 1,
      style: paddingStyle
    }, /*#__PURE__*/React.createElement(_intlDesignUi.CertificationSystem, {
      list: configuration
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}